import {
  URL_ACCOUNT_INVOICING_HISTORY,
  URL_ACCOUNT_INVOICING_PAYABLE,
  URL_ACCOUNT_PAY_INVOICES,
} from '@seek/adv-constants';
import { useLocation } from 'react-router-dom';

import { trackingViews } from '../constants';

export const useGetViewValues = () => {
  const location = useLocation();

  const routes = [
    {
      path: URL_ACCOUNT_INVOICING_HISTORY,
      view: trackingViews.INVOICE_HISTORY,
    },
    {
      path: URL_ACCOUNT_INVOICING_PAYABLE,
      view: trackingViews.PAYABLE_INVOICES,
    },
    { path: URL_ACCOUNT_PAY_INVOICES, view: trackingViews.PAY_INVOICES },
  ];

  const matchingRoute = routes.find((route) =>
    location.pathname.includes(route.path),
  );

  if (matchingRoute) {
    return matchingRoute.view;
  }

  return {};
};
